<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12 center">
                <h3 class="popa-title white">Login</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-lg-push-4 col-md-6 col-md-push-3 col-sm-6 col-sm-push-3 col-xs-12 fullh">
                <login-form></login-form>
                <div class="btn-a2hs" style="display: none; padding-top: 2em;"><img
                        src="~/../../assets/images/btn_a2hs.png" alt="Add To Home Screen"
                        style="width: 120px; height: auto; background-color: #fff;"></div>
                <br/>
                <br/>
            </div>
        </div>
    </div>
</template>
<script>
    import LoginForm from './../login-form-component/LoginFormComponent.vue'

    export default {
        components: {LoginForm}
    }
</script>